import { Platform } from 'react-native';
import ExpoConstants from 'expo-constants';
import Constants from 'src/core/utils/Constants';
import { appStoreUrl as configuredAppStoreUrl, playStoreUrl as configuredPlayStoreUrl } from 'src/core/utils/AppConfig';
import Translations from 'src/core/utils/Translations';
import type ApiSettings from 'src/core/models/api/ApiSettings';

const updateAvailableType = 'UpdateAvailable';
const mandatoryUpdateAvailableType = 'MandatoryUpdateAvailable';

const playStoreUrl: string = configuredPlayStoreUrl() ?? '';
const appStoreUrl: string = configuredAppStoreUrl() ?? '';

const AppUpdateDialogTypes = {
	UpdateAvailable: {
		dialogTitle: () => Translations.settingsUpdateAvailable,
		dialogDescription: () => Translations.settingsUpdateAvailableDescription,
		isCancellable: true,
	},
	MandatoryUpdateAvailable: {
		dialogTitle: () => Translations.settingsUpdateAvailableMandatory,
		dialogDescription: () => Translations.settingsUpdateAvailableMandatoryDescription,
		isCancellable: false,
	},
} as const;

type AppUpdateDialogKey = keyof typeof AppUpdateDialogTypes;

class AppUpdateDialogType {
	private key: AppUpdateDialogKey;

	private constructor(key: AppUpdateDialogKey) {
		this.key = key;
	}

	public static get updateAvailable(): AppUpdateDialogType {
		return new AppUpdateDialogType(updateAvailableType);
	}

	public static get mandatoryUpdateAvailable(): AppUpdateDialogType {
		return new AppUpdateDialogType(mandatoryUpdateAvailableType);
	}

	get type() {
		return this.key;
	}

	get dialogTitle() {
		return AppUpdateDialogTypes[this.key].dialogTitle();
	}

	get dialogDescription() {
		return AppUpdateDialogTypes[this.key].dialogDescription();
	}

	get isCancellable() {
		return AppUpdateDialogTypes[this.key].isCancellable;
	}

	get storeUrl() {
		if (Platform.OS === Constants.platformAndroid) {
			return playStoreUrl;
		}
		if (Platform.OS === Constants.platformIos) {
			return appStoreUrl;
		}
		return null;
	}

	get cancelButtonTitle() {
		return Translations.ignore;
	}

	get confirmButtonTitle() {
		return Translations.update;
	}

	public getDialogVersionDescription(apiSettings: ApiSettings) {
		return Translations.settingsUpdateAvailableVersionText(
			ExpoConstants.expoConfig?.version,
			apiSettings.recommended_app_version,
		);
	}
}

export default AppUpdateDialogType;
